import { useAtom } from 'jotai';
import { TagViewDialogAtom } from '../atoms/TagViewDialogAtom';

export const useTagViewDialog = () => {
  const [isOpen, setIsOpen] = useAtom(TagViewDialogAtom);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, open, close };
};
